import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";



export const slugMobile: { [key: string]: InterpolationWithTheme<any> } = {
    copyIcon: {
        height: "15px",
        float: "right"
    }
}